
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getRichTextHtml } from '@msdyn365-commerce/core';
import { Button, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { ICittaWholesaleNewsletterFormData } from './citta-wholesale-newsletter-form.data';
import { ICittaWholesaleNewsletterFormProps } from './citta-wholesale-newsletter-form.props.autogenerated';

interface ICittaWholesaleNewsletterFormState {
    firstName: string;
    lastName: string;
    emailAddress: string;
    lineOfBusiness: string;
    businessName: string;
    city: string;
    wholesaleOptIn: boolean;
    field1OptIn: boolean;
    cdpOptIn: boolean;
    cittaOptIn: boolean;
    newsletterOptIn: boolean;
    eAValError: boolean;
    eAError: boolean;
    fNError: boolean;
    lNError: boolean;
    lobError: boolean;
    bnError: boolean;
    cityError: boolean;
    tsCsError: boolean;
    rCCError: boolean;
    reqError: boolean;
    responseReceived: boolean;
    responseError: boolean;
    responseSuccess: boolean;
    charactersLeft?: number;
    firstNameErrorClass: string;
    lastNameErrorClass: string;
    emailErrorClass: string;
    privacyPolicyErrorClass: string;
    isFormSubmitting: boolean;
    reCaptchaChecked: boolean;
}

export interface ICittaWholesaleNewsletterForm {
    FormWrapper: INodeProps;
    FormContainer: INodeProps;
    firstAndLastNameInput: React.ReactNode;
    emailInput: React.ReactNode;
    lineOfBusinessInput: React.ReactNode;
    businessNameInput: React.ReactNode;
    cityInput: React.ReactNode;
    wholesaleOptIn: React.ReactNode;
    field1OptIn: React.ReactNode;
    cdpOptIn: React.ReactNode;
    checkboxPrivacyPolicy: React.ReactNode;
    wholesaleButtton: React.ReactNode;
    subscribeThanks: React.ReactNode;
    tsAndCsText: React.ReactNode;
    reCaptcha: React.ReactNode;
}


export interface ICittaWholesaleNewsletterFormViewProps extends ICittaWholesaleNewsletterFormProps<ICittaWholesaleNewsletterFormData> {
    WholesaleWrapper: IModuleProps;
    wholesaleResponse: React.ReactNode;
    wholesaleForm: ICittaWholesaleNewsletterForm;
    responseSuccess: boolean;
    formErrors: React.ReactNode;
    formErrorsNodeProps: INodeProps;
    successResponse: React.ReactNode;
    showSuccessResponse: boolean;
    successResponseNodeProps: INodeProps;
    isUnsubscribe: boolean;
}

/**
 *
 * CittaInStoreGiveawayForm component
 * @extends {React.PureComponent<ICCittaInStoreGiveawayFormProps<ICittaInStoreGiveawayFormData>>}
 */
class CittaWholesaleNewsletterForm extends React.PureComponent<ICittaWholesaleNewsletterFormProps<ICittaWholesaleNewsletterFormData>, ICittaWholesaleNewsletterFormState> {
    private _FirstNameInputRef: React.RefObject<HTMLInputElement>;
    private _LastNameInputRef: React.RefObject<HTMLInputElement>;
    private _EmailAddressInputRef: React.RefObject<HTMLInputElement>;
    private _BuisnessNameInputRef: React.RefObject<HTMLInputElement>;
    private _LineOfBuisnessInputRef: React.RefObject<HTMLInputElement>;
    private _CityInputRef: React.RefObject<HTMLInputElement>;
    private _WholesaleOptInInputRef: React.RefObject<HTMLInputElement>;
    
    private _FieldOptInInputRef: React.RefObject<HTMLInputElement>;
    private _CdpOptInInputRef: React.RefObject<HTMLInputElement>;


    private _PrivacyPolicyRef: React.RefObject<HTMLInputElement>;

    private _recaptchaRef: React.RefObject<ReCAPTCHA>;

    private firstNameValue: boolean = false;
    private lastNameValue: boolean = false;
    private emailAddressValue: boolean = false;

    private lineOfBusinessValue: boolean = false;
    private businessNameValue: boolean = false;
    private cityValue: boolean = false;

    // private phoneNumberValue: boolean = false;
    private formInputValues: boolean = false;
    private responseMessage: string | undefined;
    private moduleClassName: string = 'newsletterSubWrap';
    private recaptchaErrorMessage: string | undefined;

    constructor(props: ICittaWholesaleNewsletterFormProps<ICittaWholesaleNewsletterFormData>) {
        super(props);
        this._FirstNameInputRef = React.createRef();
        this._LastNameInputRef = React.createRef();
        this._EmailAddressInputRef = React.createRef();
        this._BuisnessNameInputRef = React.createRef();
        this._LineOfBuisnessInputRef = React.createRef();
        this._CityInputRef = React.createRef();
        this._WholesaleOptInInputRef = React.createRef();
        this._FieldOptInInputRef = React.createRef();
        this._CdpOptInInputRef = React.createRef();
        this._PrivacyPolicyRef = React.createRef();
        this._recaptchaRef = React.createRef();
        this._handleSubmit = this._handleSubmit.bind(this);

        this.state = {
            firstName: '',
            lastName: '',
            emailAddress: '',
            lineOfBusiness: '',
            businessName: '',
            city: '',
            wholesaleOptIn: false,
            field1OptIn: false,
            cdpOptIn: false,
            newsletterOptIn: false,
            cittaOptIn: false,
            fNError: false,
            lNError: false,
            eAValError: false,
            eAError: false,
            lobError: false,
            bnError: false,
            cityError: false,
            tsCsError: false,
            rCCError: false,
            reqError: false,
            responseReceived: false,
            responseError: false,
            responseSuccess: false,
            firstNameErrorClass: 'hide',
            lastNameErrorClass: 'hide',
            emailErrorClass: 'hide',
            privacyPolicyErrorClass: 'hide',
            reCaptchaChecked: false,
            isFormSubmitting: false,
        };
    }

    public render(): JSX.Element | null {
        const viewProps: ICittaWholesaleNewsletterFormViewProps = {
            ...(this.props as ICittaWholesaleNewsletterFormProps<ICittaWholesaleNewsletterFormData>),
            WholesaleWrapper: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName)
            },
            wholesaleResponse: this._getSubmitResponse(),
            wholesaleForm: this._renderForm(),
            responseSuccess: this.state.responseSuccess,
            formErrors: this._renderErrors(),
            formErrorsNodeProps: {
                className: 'competition-form-errors'
            },
            successResponse: this._renderSuccessResponse(),
            showSuccessResponse: this.state.responseSuccess,
            successResponseNodeProps: {
                className: 'competition-form-success'
            },
            isUnsubscribe: !!this.props.config.isUnsubscribe
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }

    private _getSubmitResponse(): React.ReactNode {
        return (
            this.state.responseReceived && this.responseMessage !== '' || undefined
                ? (
                    <div className={`response-message ${this.state.responseError ? 'response-error' : ''}`}>
                        <p className='response-message-content'>{this.responseMessage}</p>
                    </div>
                )
                : null
        );
    }

    private _renderSuccessResponse(): React.ReactNode {
        return (
            this.state.responseSuccess
                ? (
                    <div className="response-succcess">
                        <h2>{this.props.config.successTextResponse}</h2>
                    </div>
                )
                : null
        );
    }

    private _renderForm(): ICittaWholesaleNewsletterForm {
        return {
            FormWrapper: {
                className: 'competition-form',
            },
            FormContainer: {
                className: 'competition-form-div',
            },
            firstAndLastNameInput: this._renderFirstAndLastNameInput(),
            emailInput: this._renderEmailInput(),

            lineOfBusinessInput: this._renderLineOfBusinessInput(),
            businessNameInput: this._renderBusinessNameInput(),
            cityInput: this._renderCityInput(),
            cdpOptIn: this._renderCdpOptIn(),
            wholesaleOptIn: this._renderWholesaleOptIn(),
            field1OptIn: this._renderField1OptIn(),
            checkboxPrivacyPolicy: this._renderCheckboxPrivacyPolicy(),
            wholesaleButtton: this._renderSubmitButton(),
            subscribeThanks: this._renderSubmitThanks(),
            tsAndCsText: this._renderTsCsText(),
            reCaptcha: this._renderReCaptcha()
        };
    }

    private _renderRecaptchaAlert(className: string): JSX.Element {

        if (this.props.config.reCaptchaOption) {
            if (!this.state.reCaptchaChecked) {
                this.recaptchaErrorMessage = this.props.resources.recaptchaErrorMessage;
            }
        }

        const rCCError = this.state.rCCError;
        return (
            <>
                {rCCError && (
                    <span className={`${className}__alert`} role='alert' aria-live='assertive'>
                        {
                            this.recaptchaErrorMessage &&
                            <>
                                <span className={`${className}__alert-icon`} aria-hidden='true' />
                                {this.recaptchaErrorMessage}
                            </>
                        }
                    </span>
                )}
            </>
        );
    }

    private _renderReCaptcha(): React.ReactNode {
        //recaptcha newsletter-recapture-visable
        return (
            <div>
                {
                    this.props.config.reCaptchaOption ? <div className=''>
                        {this.state.rCCError ? this._renderRecaptchaAlert('recaptcha-error') : ''}

                        <ReCAPTCHA
                            ref={this._recaptchaRef}
                            sitekey={this.props.config.reCaptchaSiteKey!}
                            size="invisible"
                            onChange={() => this._submit()}
                        />
                    </div> : null
                }
            </div>
        );
    }

    private _renderFirstAndLastNameInput(): React.ReactNode {
        return (
            <div className='name-input-container'>
                <div className='name-input'>
                    <input
                        ref={this._FirstNameInputRef}
                        type='text'
                        onChange={this._handleChange('firstName')}
                        aria-label='First Name'
                        className='first-name-input-text'
                        placeholder={this.props.config.firstNamePlaceholderText}
                        value={this.state.firstName}
                        required
                    />
                </div>
                <div className='name-input'>
                    <input
                        ref={this._LastNameInputRef}
                        type='text'
                        onChange={this._handleChange('lastName')}
                        aria-label='First Name'
                        className='name-input-text'
                        placeholder={this.props.config.lastNamePlaceholderText}
                        value={this.state.lastName}
                        required
                    />
                </div>
            </div>
        );
    }

    private _renderTsCsText(): React.ReactNode {
        return (
            <div className='terms-and-conditions-richtext'>
                <span dangerouslySetInnerHTML={getRichTextHtml(this.props.config.privacyPolicyText)} />
            </div>
        );
    }

    private _renderEmailInput(): React.ReactNode {
        return (
            <div className='email-address-input'>
                {this.state.eAError || this.state.eAValError ? this._renderAlert('email-address-input') : ''}
                <input
                    ref={this._EmailAddressInputRef}
                    type='email'
                    onChange={this._handleChange('emailAddress')}
                    aria-label='Email Address'
                    className='email-address-input-text'
                    value={this.state.emailAddress}
                    required
                    placeholder={this.props.config.emailInputPlaceholder}
                />
            </div>
        );
    }

    private _renderBusinessNameInput(): React.ReactNode {
        return (
            <div className='businessname-input'>
                {this.state.bnError ? this._renderAlert('businessname-input') : ''}
                <input
                    ref={this._BuisnessNameInputRef}
                    type='text'
                    onChange={this._handleChange('businessname')}
                    aria-label={this.props.config.businessNamePlaceholder}
                    className='businessname-input-text'
                    value={this.state.businessName}
                    required
                    placeholder={this.props.config.businessNamePlaceholder}
                />
            </div>
        );
    }


    private _renderLineOfBusinessInput(): React.ReactNode {
        return (
            <div className='lob-input'>
                {this.state.lobError ? this._renderAlert('lob-input') : ''}
                <input
                    ref={this._LineOfBuisnessInputRef}
                    type='text'
                    onChange={this._handleChange('lineofbusiness')}
                    aria-label={this.props.config.lineOfBusinessPlaceholder}
                    className='lob-input-text'
                    value={this.state.lineOfBusiness}
                    required
                    placeholder={this.props.config.lineOfBusinessPlaceholder}
                />
            </div>
        );
    }

    private _renderCityInput(): React.ReactNode {
        return (
            <div className='city-input'>
                {this.state.eAError || this.state.eAValError ? this._renderAlert('city-input') : ''}
                <input
                    ref={this._CityInputRef}
                    type='text'
                    onChange={this._handleChange('city')}
                    aria-label='City'
                    className='city-input-text'
                    value={this.state.city}
                    required
                    placeholder={'City'}
                />
            </div>
        );
    }

    private _renderCdpOptIn(): React.ReactNode {
        if (this.props.config.cdpText && this.props.config.emarsysCdpFieldId) {
            return (
                <div className='checkbox-opt-in'>
                    <div className='checkbox-privacy-policy-content'>
                        <input
                            ref={this._CdpOptInInputRef}
                            type='checkbox'
                            className='cdp-text'
                            aria-label='CDP Opt In'
                            aria-checked='false'
                            onChange={this._handleChange('cdpOptIn')}
                            id='cdpOptInCheckbox'
                        />
                        <span className='checkbox-privacy-policy-text'>
                            <p>{`${this.props.config.cdpText}`}</p>
                        </span>

                    </div>
                </div>
            );
        }
        return null;
    }

    private _renderWholesaleOptIn(): React.ReactNode {
        return (
            <div className='checkbox-opt-in'>
                <div className='checkbox-privacy-policy-content'>
                    <input
                        ref={this._WholesaleOptInInputRef}
                        type='checkbox'
                        className='cdp-text'
                        aria-label='CDP Opt In'
                        aria-checked='false'
                        onChange={this._handleChange('wholesaleOptIn')}
                        id='wholesaleOptInCheckbox'
                    />
                    <span className='checkbox-privacy-policy-text'>
                        <p>{`${this.props.config.wholesaleText}`}</p>
                    </span>

                </div>
            </div>
        );
    }

    private _renderField1OptIn(): React.ReactNode {
        if (this.props.config.textFieldOne && this.props.config.emarsysFieldIdOne) {
            return (
                <div className='checkbox-opt-in'>
                    <div className='checkbox-privacy-policy-content'>
                        <input
                            ref={this._FieldOptInInputRef}
                            type='checkbox'
                            aria-label='field 1 Opt In'
                            aria-checked='false'
                            onChange={this._handleChange('field1OptIn')}
                            id='field1OptInCheckbox'
                        />
                        <span className='checkbox-privacy-policy-text'>
                            <p>{`${this.props.config.textFieldOne}`}</p>
                        </span>

                    </div>
                </div>
            );
        } 
        return null;
    }

    private _renderAlert(className: string): JSX.Element {
        return <></>;
    }

    private _renderCheckboxPrivacyPolicy(): React.ReactNode {
        if (this.props.config.privacyPolicyText && this.props.config.emarsysCittaFieldId) {
            return (
                <div>
                    {this.state.tsCsError ? this._renderAlert('checkbox-privacy-policy') : ''}
                    <div className='checkbox-privacy-policy-content'>
                        <input
                            ref={this._PrivacyPolicyRef}
                            type='checkbox'
                            className='privacy-policy-text'
                            aria-label='Accept Privacy Policy'
                            aria-checked='false'
                            onChange={this._handleChange('cittaOptIn')}
                            id='privacyPolicyCheckbox'
                        />
                        <span className='checkbox-privacy-policy-text'>
                            <p>{`${this.props.config.privacyPolicyText}`}</p>
                        </span>
                    </div>
                </div>
            );
        } else  {
            return null;
        }
    }

    private _renderSubmitButton(): React.ReactNode {
        const { isFormSubmitting } = this.state;
        const { isUnsubscribe } = this.props.config;

        return (
            <div className="subscribe-button-container">
                <Button
                    className={`subscribe-button btn-thirdary ${isFormSubmitting ? 'button--loading' : ''}`}
                    title={this.props.config.submitButtonLabel}
                    color='primary'
                    onClick={this._handleSubmit}
                >{isUnsubscribe ? 'unsubscribe' : (isFormSubmitting ? '' : this.props.config.submitButtonLabel)}
                </Button>
            </div>
        );
    }

    private _renderSubmitThanks(): React.ReactNode {
        return (
            <div>
                <div className={`subscribe-thanks`}>
                    Thanks for Entering!
                </div>
            </div>
        );
    }

    private _showErrors = (): void => {
        this.setState({
            emailErrorClass: this._checkEmailError() ? 'show' : 'hide',
            firstNameErrorClass: (this._FirstNameInputRef.current && this._FirstNameInputRef.current.value.length === 0) ? 'show' : 'hide',
            lastNameErrorClass: (this._LastNameInputRef.current && this._LastNameInputRef.current.value.length === 0) ? 'show' : 'hide'
        });
    }

    private _checkEmailError = (): boolean => {
        const email: string = this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value || '';
        if (email.length === 0) {
            return true;
        } else {
            return !this._isEmailValid(email);
        }
    }

    private _renderErrors = (): JSX.Element => {
        const {resources} = this.props;
        return (
            <>
                <div className={this.state.firstNameErrorClass}>
                    {resources.firstNameError}
                </div>
                <div className={this.state.lastNameErrorClass}>
                    {resources.lastNameError}
                </div>
                <div className={this.state.emailErrorClass}>
                    {resources.emailError}
                </div>
                <div className={this.state.privacyPolicyErrorClass}>
                    {resources.ppError}
                </div>
            </>
        );
    }

    private _handleChange = (name: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        switch (name) {
            case 'firstName': {
                this.setState({ firstName: value, fNError: false, reqError: false, eAValError: false });
                break;
            }
            case 'lastName': {
                this.setState({ lastName: value, lNError: false, reqError: false, eAValError: false });
                break;
            }
            case 'emailAddress': {
                this.setState({ emailAddress: value, eAError: false, reqError: false, eAValError: false });
                break;
            }
            case 'lineofbusiness': {
                this.setState({ lineOfBusiness: value, lobError: false, reqError: false, eAValError: false });
                break;
            }
            case 'businessname': {
                this.setState({ businessName: value, bnError: false, reqError: false, eAValError: false });
                break;
            }
            case 'city': {
                this.setState({ city: value, cityError: false, reqError: false, eAValError: false });
                break;
            }
            case 'cdpOptIn': {
                const isChecked = this._CdpOptInInputRef.current && this._CdpOptInInputRef.current.checked ? this._CdpOptInInputRef.current.checked : false;
                this.setState({ cdpOptIn: isChecked, reqError: false, eAValError: false });
                break;
            }
            case 'wholesaleOptIn': {
                const isChecked = this._WholesaleOptInInputRef.current && this._WholesaleOptInInputRef.current.checked ? this._WholesaleOptInInputRef.current.checked : false;
                this.setState({ wholesaleOptIn: isChecked, reqError: false, eAValError: false });
                break;
            }
            case 'field1OptIn' : {
                const isChecked = this._FieldOptInInputRef.current && this._FieldOptInInputRef.current.checked ? this._FieldOptInInputRef.current.checked : false;
                this.setState({ field1OptIn: isChecked, reqError: false, eAValError: false });
                break;
            }

            case 'cittaOptIn': {
                const isChecked = this._PrivacyPolicyRef.current && this._PrivacyPolicyRef.current.checked ? this._PrivacyPolicyRef.current.checked : false;
                this.setState({ cittaOptIn: isChecked, reqError: false, eAValError: false });
                break;
            }
            default: {
                console.log('No input box changes');
                this.setState({ reqError: false, eAValError: false });
            }
        }
    }

    private _isEmailValid = (email: string): boolean => {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    };

    private async _handleSubmit(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLFormElement>): Promise<void> {
        await this._recaptchaRef.current?.execute()
    }

    private async _submit(): Promise<void> {
        const { isUnsubscribe } = this.props.config;
        if (isUnsubscribe) {
            this._submitOptOut();
        }
        this._submitOptIn();
    }

    private async _submitOptOut(): Promise<void> {
        this.emailAddressValue = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? true : false;

        const eA = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? this._EmailAddressInputRef.current.value : '';
        
        const wsOptIn = this._WholesaleOptInInputRef.current!.checked;
        const f1OptIn = this._FieldOptInInputRef.current && this._FieldOptInInputRef.current!.checked;
        const cdpOptIn = (this._CdpOptInInputRef && this._CdpOptInInputRef.current && this._CdpOptInInputRef.current!.checked) ? true : false;
        const cittaOptIn = this._PrivacyPolicyRef.current && this._PrivacyPolicyRef.current!.checked;

        const eAVal = this._EmailAddressInputRef.current!.value;
        const recaptchaValue = this._recaptchaRef.current?.getValue();

        if (!this.emailAddressValue) {
            this.setState({
                eAError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this._isEmailValid(eAVal)) {
            this.setState({
                eAValError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!recaptchaValue) {
            this.setState({
                rCCError: true
            });
            this._recaptchaRef.current?.reset();
        } else {
            this.formInputValues = (this.emailAddressValue) ? true : false;
            if (this.formInputValues && !this.state.eAValError) {
                this.setState({ isFormSubmitting: true })
                try {
                    await this._postOptOutEntry(eA, wsOptIn, cdpOptIn, cittaOptIn, f1OptIn);

                    this._clearValues();
                    setTimeout(() => {
                      window.location.reload();
                    }, 6000);
                } catch (e) {
                    console.log(e, 'Please fill in the form!');
                }
            }
        }
    }

    private async _postOptOutEntry(
        email: string,
        wsOptIn: boolean,
        cdpOptIn: boolean,
        cittaOptIn: boolean | null,
        f1OptIn: boolean | null
    ): Promise<void> {
        /* tslint:disable */
        const response = await MsDyn365.commerceApiRequest(
            this.props.context.request,
            'PostWholesaleOptOutContact',
            'post',
            {
                emailAddress: email,
                wsOptIn: wsOptIn,
                cdpOptIn: cdpOptIn,
                f1OptIn: f1OptIn, 
                cittaOptIn: cittaOptIn,
                country: this.props.config.country,
                emarsysCdpFieldId: this.props.config.emarsysCdpFieldId,
                emarsysWholesaleFieldId: this.props.config.emarsysWholesaleFieldId,
                emarsysCittaFieldId: this.props.config.emarsysCittaFieldId,
                emarsysFieldIdOne: this.props.config.emarsysFieldIdOne,
                isOptIn: false
            }

        ) as any;

        this.responseMessage = response?.data.Message;
        this.setState({
            responseReceived: true,
            responseError: response?.data.Result === 'Error',
            responseSuccess: response?.data.Result !== 'Error',
            emailAddress: '',
            reqError: false,
            eAValError: false,
            rCCError: false,
            isFormSubmitting: false
        });
        /* tslint:enable */
    }

    private async _submitOptIn(): Promise<void> {
        this._showErrors();

        this.firstNameValue = (this._FirstNameInputRef && this._FirstNameInputRef.current && this._FirstNameInputRef.current.value) ? true : false;
        this.lastNameValue = (this._LastNameInputRef && this._LastNameInputRef.current && this._LastNameInputRef.current.value) ? true : false;
        this.emailAddressValue = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? true : false;

        this.lineOfBusinessValue = (this._LineOfBuisnessInputRef && this._LineOfBuisnessInputRef.current && this._LineOfBuisnessInputRef.current.value) ? true : false;
        this.businessNameValue = (this._LineOfBuisnessInputRef && this._LineOfBuisnessInputRef.current && this._LineOfBuisnessInputRef.current.value) ? true : false;
        this.cityValue = (this._CityInputRef && this._CityInputRef.current && this._CityInputRef.current.value) ? true : false;

        const fN = (this._FirstNameInputRef && this._FirstNameInputRef.current && this._FirstNameInputRef.current.value) ? this._FirstNameInputRef.current.value : '';
        const lN = (this._LastNameInputRef && this._LastNameInputRef.current && this._LastNameInputRef.current.value) ? this._LastNameInputRef.current.value : '';
        const eA = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? this._EmailAddressInputRef.current.value : '';
        const bn = (this._BuisnessNameInputRef && this._BuisnessNameInputRef.current && this._BuisnessNameInputRef.current.value) ? this._BuisnessNameInputRef.current.value: '';
        const lob = (this._LineOfBuisnessInputRef && this._LineOfBuisnessInputRef.current && this._LineOfBuisnessInputRef.current.value) ? this._LineOfBuisnessInputRef.current.value : '';
        const city = (this._CityInputRef && this._CityInputRef.current && this._CityInputRef.current.value) ? this._CityInputRef.current.value : '';

        const f1OptIn = this._FieldOptInInputRef.current && this._FieldOptInInputRef.current!.checked;
        const wsOptIn = this._WholesaleOptInInputRef.current!.checked;
        const cdpOptIn = (this._CdpOptInInputRef && this._CdpOptInInputRef.current && this._CdpOptInInputRef.current!.checked) ? true : false;
        const cittaOptIn = this._PrivacyPolicyRef.current && this._PrivacyPolicyRef.current!.checked;

        const eAVal = this._EmailAddressInputRef.current!.value;
        const recaptchaValue = this._recaptchaRef.current?.getValue();

        if (!this.firstNameValue) {
            this.setState({
                fNError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this.lastNameValue) {
            this.setState({
                lNError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
         } else if (!this.emailAddressValue) {
            this.setState({
                eAError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this._isEmailValid(eAVal)) {
            this.setState({
                eAValError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this.lineOfBusinessValue) {
            this.setState({
                lobError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this.businessNameValue) {
            this.setState({
                bnError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this.cityValue) {
            this.setState({
                cityError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
         }
        else if (!recaptchaValue) {
            this.setState({
                rCCError: true
            });
            this._recaptchaRef.current?.reset();
        } else {
            this.formInputValues = (this.emailAddressValue) ? true : false;
            if (this.formInputValues && !this.state.eAValError) {
                this.setState({ isFormSubmitting: true })
                try {
                    await this._postEntry(fN, lN, eA, bn, lob, city, wsOptIn, cdpOptIn, cittaOptIn, f1OptIn);

                    this._clearValues();
                    setTimeout(() => {
                      window.location.reload();
                    }, 6000);
                } catch (e) {
                    console.log(e, 'Please fill in the form!');
                }
            }
        }
    }

    private async _postEntry(
        firstName: string,
        lastName: string,
        email: string,
        businessName: string,
        lineOfBusiness: string,
        city: string,
        wsOptIn: boolean,
        cdpOptIn: boolean,
        cittaOptIn: boolean | null,
        f1OptIn: boolean | null
    ): Promise<void> {
        /* tslint:disable */
        const response = await MsDyn365.commerceApiRequest(
            this.props.context.request,
            'PostWholesaleContact',
            'post',
            {
                firstName: firstName,
                lastName: lastName,
                emailAddress: email,
                businessName: businessName,
                lineOfBusiness: lineOfBusiness,
                city: city,
                wsOptIn: wsOptIn,
                cdpOptIn: cdpOptIn,
                cittaOptIn: cittaOptIn,
                f1OptIn: f1OptIn,
                country: this.props.config.country,
                emarsysCdpFieldId: this.props.config.emarsysCdpFieldId,
                emarsysWholesaleFieldId: this.props.config.emarsysWholesaleFieldId,
                emarsysLineOfBusinessFieldId: this.props.config.emarsysLineOfBusinessFieldId,
                emarsysBusinessNameFieldId: this.props.config.emarsysBusinessNameFieldId,
                emarsysCittaFieldId: this.props.config.emarsysCittaFieldId,
                emarsysFieldIdOne: this.props.config.emarsysFieldIdOne,
                isOptIn: true
            }

        ) as any;

        this.responseMessage = response?.data.Message;
        this.setState({
            responseReceived: true,
            responseError: response?.data.Result === 'Error',
            responseSuccess: response?.data.Result !== 'Error',
            emailAddress: '',
            firstName: '',
            lastName: '',
            businessName: '',
            lineOfBusiness: '',
            reqError: false,
            eAValError: false,
            rCCError: false,
            isFormSubmitting: false
        });
        /* tslint:enable */
    }

    private _clearValues(): void {
        this._recaptchaRef.current?.reset();
        if (this._FirstNameInputRef.current) {
            this._FirstNameInputRef.current!.value = '';
        }
        if (this._LastNameInputRef.current) {
            this._LastNameInputRef.current!.value = '';
        }
        if (this._BuisnessNameInputRef.current) {
            this._BuisnessNameInputRef.current!.value = '';
        }
        if (this._LineOfBuisnessInputRef.current) {
            this._LineOfBuisnessInputRef.current!.value = '';
        }
        if (this._CityInputRef.current) {
            this._CityInputRef.current!.value = '';
        }
        if (this._PrivacyPolicyRef.current) {
            this._PrivacyPolicyRef.current.checked = false;
        }
        if (this._CdpOptInInputRef.current) {
            this._CdpOptInInputRef.current.checked = false;
        }
        if (this._WholesaleOptInInputRef.current) {
            this._WholesaleOptInInputRef.current.checked = false;
        }
        if (this._EmailAddressInputRef.current) {
            this._EmailAddressInputRef.current!.value = '';
        }
        if (this._FieldOptInInputRef.current) {
            this._FieldOptInInputRef.current.checked = false;
        }
    }

}

export default CittaWholesaleNewsletterForm;
